import AnionTestingPart from './AnionTestingPart';

export default function Part2Chloride() {
  return (
    <AnionTestingPart
      partNumber={2}
      anionSymbol="Cl-"
      anionName="Chloride"
      anionFormula="0.1 M NaCl"
      anionColor="#E3F2FD"
      infoContent={{
        title: 'Chloride Solubility',
        content: 'Most chlorides are soluble. Look for white precipitate with Ag+ (silver chloride, AgCl). This is a characteristic test for silver ions.',
        equation: 'Ag+(aq) + Cl-(aq) -> AgCl(s) [white curdy precipitate]'
      }}
    />
  );
}
